import { render, staticRenderFns } from "./IrisTextfieldDropdown.vue?vue&type=template&id=6993b47f&"
import script from "./IrisTextfieldDropdown.vue?vue&type=script&lang=ts&"
export * from "./IrisTextfieldDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports